import { createApi } from '@reduxjs/toolkit/query/react';

import { apiSupplementsLookup } from '~constants/api';

import { Request, rtkBaseQueryWrapper, unwrap } from '~libs/axiosWrapper';

import { SupplementRate } from '~lookups/models';

export const typePrefix = 'supplements-lookup';

export const supplementsLookupApi = createApi({
  reducerPath: 'supplementsLookupApi',
  baseQuery: rtkBaseQueryWrapper({ baseUrl: apiSupplementsLookup }),
  tagTypes: ['supplements-lookup'],
  endpoints: (builder) => ({
    getLookupSupplements: builder.query<SupplementRate[], Request | void>({
      query: (params) => ({ url: '', method: 'GET', params }),
      providesTags: [{ type: 'supplements-lookup', id: 'LIST' }],
      transformResponse: (payload) => unwrap<SupplementRate[]>(payload),
    }),
  }),
});

export const { useGetLookupSupplementsQuery } = supplementsLookupApi;
